// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"bc18e7d5","905":"443799ca"}[chunkId] + ".chunk.css";
};